"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Typography } from "@mui/material";
import { FontWeightBold } from "@nxt-costco-com/forge-design-tokens";
import { getDataTestId } from "../../Util/index.js";
const COMPONENT_NAME = "Text";
const INVALID_PROP_ERROR = `${COMPONENT_NAME}-error: Missing children prop`;
const Text = forwardRef((props, ref) => {
  const {
    children,
    variant = "bodyCopy",
    component = "div",
    bold = false,
    italic = false,
    sx,
    color = "default",
    underline = false,
    uniqueId,
    ...rest
  } = props;
  if (!children) {
    console.error(INVALID_PROP_ERROR);
    return null;
  }
  const underlineText = underline ? { textDecoration: "underline" } : {};
  const fontWeight = bold ? { fontWeight: FontWeightBold } : {};
  const fontStyle = italic ? { fontStyle: "italic" } : {};
  const textColor = color ? { color: `text.${color}` } : {};
  const computedStyles = [
    {
      ...underlineText,
      ...fontWeight,
      ...fontStyle,
      ...textColor
    },
    ...Array.isArray(sx) ? sx : [sx]
  ];
  return /* @__PURE__ */ jsx(
    Typography,
    {
      ...rest,
      "data-testid": getDataTestId(COMPONENT_NAME, uniqueId),
      variant,
      component,
      sx: computedStyles,
      ref,
      children
    }
  );
});
Text.displayName = COMPONENT_NAME;
export {
  Text
};
